module.exports = __webpack_public_path__ + "img/vlogo.30fb005e.png";